export type Typing = { text: string; startMs: number; msPerChar: number };

// The text the onboarding film types, timed from the start of its scene. The miniature types it,
// and the scene table cues the moment each one is done.
export const TYPING = {
  title: { text: 'Coupon lookup', startMs: 250, msPerChar: 45 },
  body: {
    text: 'findCoupon normalizes codes and rejects unknown, expired, or below-minimum coupons.',
    startMs: 900,
    msPerChar: 22,
  },
  question: { text: 'Why does an expired code fail?', startMs: 300, msPerChar: 45 },
} satisfies Record<string, Typing>;

export const typedAt = ({ text, startMs, msPerChar }: Typing) => startMs + text.length * msPerChar;
